import React , {memo}from "react";

export const UiInputGroupWr = memo((props) => {
    const { children,title,className } = props;
return (
    <div className={`${className} ${"sbt-styled-input__group-wr"}`}>
        <h1>{title}</h1>
        {children}
    </div>
)
})

export const SearchBarWr = memo((props) => {
    const { children} = props;
return (
    <div className="sbt-searchbar-wr">
        {children}
    </div>
)
})
export const SearchBarAccordinaWr = memo((props) => {
    const { children} = props;
return (
    <div className="sbt-searchbar-wr sbt-accordian-searchbar-wr">
        {children}
    </div>
)
})

